import { io } from 'socket.io-client';

const socket = io('http://88.222.212.192:8300' || 'https://chat.fynito.com/', {
    // Add proper configuration options
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    autoConnect: true,
    transports: ['websocket', 'polling']
});

// Add error handling
socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error);
});

// socket.on('connect', () => {
//     console.log('Socket connected successfully');
// });

export default socket;
